export const menuFallback = [
  { id: 1, title: "Inicio",             url: "/",                       order: 1, active: true },
  { id: 2, title: "Sobre Nosotros",     url: "/nosotros",               order: 2, active: true },
  { id: 3, title: "Gestión Humana",     url: "/recursohumano",          order: 3, active: true },
  { id: 4, title: "Socios Comerciales", url: "/socios-comerciales",     order: 4, active: true },
  { id: 5, title: "Productos",          url: "/productos",              order: 5, active: true },
  { id: 6, title: "Contacto",           url: "/contacto",               order: 6, active: true },
];
